import React from "react";
import "./Footer.css"; // Import the CSS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons"; // Import the icons
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column contact">
          <h3>Clinic</h3>
          <p className="bdc">
            Bombay Dental company Atur House First Floor, Flat no 2 Worli Naka,
            Worli Mumbai 400018
          </p>
          <p className="bdc">
            <Link to="tel:+918882672980">088826 72980</Link>
          </p>
          <p className="bdc">
            <Link to="tel:+919582474046">095824 74046</Link>
          </p>
          <p className="bdc">
            <Link to="mailto:bombaydentalcompany@gmail.com">
              bombaydentalcompany@gmail.com
            </Link>
          </p>
        </div>

        <div className="footer-column services">
          <h3>Services</h3>
          <ul>
            <li>
              <Link to="/problem" className="foot">
                Problems we treat
              </Link>
            </li>
            <li>
              <Link to="/invisalign" className="foot">
                Invisalign
              </Link>
            </li>
            <li>
              <Link to="/braces" className="foot">
                Braces (Orthodontics)
              </Link>
            </li>
            <li>
              <Link to="/surgical" className="foot">
                Surgical
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column office">
          <h3>Our Office</h3>
          <ul>
            <li>
              <Link to="/" className="foot">
                Home
              </Link>
            </li>
            <li>
              <Link to="/meet-the-doctors" className="foot">
                About
              </Link>
            </li>
            <li>
              <Link to="/newpatient" className="foot">
                New Patients
              </Link>
            </li>
            <li>
              <Link to={"/booknow"} className="foot">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column social">
          <h3>Social</h3>
          <div className="social-icons">
            {/* External links should remain as <a> tags */}
            <a
              href="https://www.facebook.com/share/15jNGvqWPf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} size="2x" />
            </a>
            <a
              href="https://www.instagram.com/bombaydentalcompany"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
          </div>
          <div className="image-foot"></div>

          {/* New Section for Image */}
          {/* <div className="footer-column image-section">
         
      
        </div> */}
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © Bombay Dental {new Date().getFullYear()}024 |
          <Link to="/privacy-policies"> Privacy Policy </Link>|
          <Link to="/term-and-conditions"> Terms & Conditions </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
